import React from "react";
import { withRouter } from "react-router-dom";
import CheckoutPackage from "~/components/checkoutPackage";

const CheckoutPackagePage = () => {
	return <CheckoutPackage />;
};

export default withRouter(CheckoutPackagePage);
